<template>
  <div class="datepicker">
    <input type="text" class="inp_date" :style="{width}" :value="selectedDateText" @change="onChangeInput" ref="input" :readonly="readonly">

    <!-- 주간일 경우 클래스 weekly 추가 -->
    <div v-if="buttonContainerView" class="datepicker_container" :class="buttonContainerClass">
      <div class="datepicker_header">
        <a class="prev" title="이전 달" :class="{'disabled': prevMonthDisabled}">
          <span class="ico" @click="tickCurrentMonth(-1)">이전 달</span>
        </a>
        <a class="next" title="다음 달" :class="{'disabled': nextMonthDisabled}">
          <span class="ico" @click="tickCurrentMonth(1)">다음 달</span>
        </a>
        <div class="title">
          <select class="date" v-model="currentYear">
            <option v-for="year in selectableYearList" :value="year" :key="year">{{year}}</option>
          </select>년
          <select class="date" v-model="currentMonth">
            <option v-for="month in selectableMonthList" :value="month" :key="month">{{month + 1}}월</option>
          </select>
        </div>
      </div>

      <table class="datepicker_calendar">
        <thead>
        <tr>
          <th v-for="day in dayList" :key="day"><span :title="day">{{day}}</span></th>
        </tr>
        </thead>
        <tbody>
          <tr v-for="(item, index) in dateList" :key="index">
            <template v-for="(date, sIndex) in item">
              <td :key="sIndex" :class="{'disabled': date.disabled, 'another_month': !date.isCurrentMonth}">
                <a class="default" href="#" @click.prevent="setDate(date)" :class="buttonClass(date)">{{date.getDate()}}</a>
              </td>
            </template>
          </tr>
        </tbody>
      </table>
    </div>
  </div>
</template>

<script>
import datepicker from '$mixins/datepicker'
import toggleContainer from '$mixins/toggleContainer'


export default {
  mixins: [datepicker, toggleContainer],
  props: {
    width: {
      type: String
    },
    readonly: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      buttonContainerClass: ''
    }
  },
  watch: {
    selectedDate() {
      this.toggleButtonContainer(false)
    },
    buttonContainerView() {
      this.syncCurrentAndSelected()
    }
  },
  computed: {
    selectedDateText() {
      return this.$utils.dateformat(this.selectedDate, this.format)
    },
  },
  methods: {
    onChangeInput(e) {
      this.setDate(e.target.value)
    },
    buttonClass(date) {
      return {
        'today': date.isToday,
        'active': date.isSelectedDate,
        'week_active': date.isSelectedWeek
      }
    }
  },
  mounted() {
    this.$on('setDateError', () => this.$refs.input.focus())
  }
}
</script>
